import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { PublikationSection } from '@/components/sections/PublikationSection';
import { publikationen } from '@/lib/content/veroeffentlichungen';

const seo = {
  title: 'Marlene Gujan Architektur AG| Publikationen',
  description: 'Entdecken Sie die neuesten Publikationen der Marlene Gujan Architektur AG in Igis. Erfahren Sie mehr über unsere Projekte und Innovationen.',
  keywords: 'Publikationen, Marlene Gujan, Architektur, Igis, Projekte, Innovationen',
  canonicalUrl: 'https://www.gujan-architektur.ch/buero/publikationen',
};

export default function Publikationen({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <PublikationSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  return { props: { data: await publikationen() }, revalidate: 300 };
}
